/**
 * Canonical college master list for the Social Media module.
 *
 * - `COLLEGES`: the real-world colleges. Used by analytics surfaces such as
 *   the Account & College Tracker where a "NA" bucket would be noise.
 * - `COLLEGES_FOR_SELECT`: the same list plus a trailing "NA" entry. Used by
 *   form selectors (Create / Edit / Filter / Bulk Update modals + Calendar
 *   swimlane) so users can mark a post as not tied to a specific college.
 *
 * Add new colleges here ONCE — every consumer picks them up automatically.
 */
export const COLLEGES = [
  'Vels',
  'Bharath',
  'Crescent',
  'Jamal',
  'Bishop',
  'Alliance',
  'Kalasalingam',
  'Ganpat',
  'Sasuri-Tirupur',
  'Sanskrit',
];

export const COLLEGES_FOR_SELECT = [...COLLEGES, 'NA'];

export default COLLEGES;
